import React from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Progress,
    FormTextarea,
    Button,
    ButtonGroup,
    Form,
    FormInput
} from "shards-react";
import { fetchPost, fetchGet } from '../utils/api';
import ReactStars from 'react-stars';
import { withRouter } from 'react-router-dom';
import { storage } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

class Review extends React.Component {
    state = {
        section: 0,
        progress: 0,
        canContinue: false,
        submitted: false,
        job: null,
        googleReview: false,
        url: '',
        is_loading_google: false,
        onSignClicked: false,
        isSubmitted: false,
        onUploadClicked: false,
        isElectronicSignature: false,
        isManualSignature: false,
        isOtpSubmitted: false,
        otp: '',
        isOTPValid: true,
        user_form: null,
        isAcceptanceFormViewed: false,
        uploaded_file: '',
        isAlreadySigned: false
    }

    componentDidMount() {
        this.onFetchJobDetails()
    }

    sections() {
        const sections = [
            { head: 'Hi, Customer!', description: 'We hope you are satisfied with the level of service you received today. Please help us better it by completing this quick review', image: require('../assets/images/rating.png').default, hasContinue: true },
            { head: 'Issue Fixed', description: "Was your issue resolved? Did the agent fix the fault?", foot: 'thumb down = NO | thumb up = YES', field: 'issue_resolved', boolean: true, hasNext: true },
            { head: 'Agent Conduct', description: "Were you happy with the agent's conduct?", foot: '1 star = TERRIBLE | 5 stars = SUPERB', field: 'agent_interaction', stars: true, hasPrev: true, hasNext: true },
            { head: 'Process Time', description: "Were you happy with how long it took to get your issue resolved or your fault fixed?", foot: '1 star = TOO SLOW | 5 stars = SPEEDY SERVICE', field: 'turnaround_satisfaction', stars: true, hasPrev: true, hasNext: true },
            // { head: 'Product Satisfaction', description: 'Are you generally happy with the product you bought?', foot: '1 star = HATE IT | 5 stars = LOVE IT', field: 'product_satisfaction', stars: true, hasPrev: true, hasNext: true },
            { head: 'Overall Satisfaction', description: 'Are you generally happy with the service you received?', foot: '1 star = TERRIBLE | 5 stars = SUPERB', field: 'overall_satisfaction', stars: true, hasPrev: true, hasNext: true },
            // { head: 'Recommendation', description: 'Are you likely to recommend this product to someone?', foot: 'thumb down = NO | thumb up = YES', field: 'likely_to_recommend', boolean: true, hasPrev: true, hasNext: true, hasComplete: false },
            { head: 'Comments', description: '(optional) Do you have any additional comments, compliments or complaints?', foot: null, optional: true, field: 'review_note', text: true, hasPrev: true, hasNext: false, hasComplete: true }
        ]

        return sections
    }


    handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('document', file);

        try {
            await fetch('http://localhost:3001/api/review/upload', {
                method: 'POST',
                body: formData
            });

            alert('Upload successful');
        } catch (err) {
            console.error(err);
            alert('Upload failed');
        }
    };

    onFetchJobDetails() {
        const jobN0 = this.props.location.pathname.replace(/\//g, '')
        if (jobN0.includes('NPA')) {
            fetchPost('/complete/signature/' + this.props.match.params.token, {},
                (response) => {
                    console.log(response)
                    this.setState({ job: response, user_form: response['user_form'] })
                },
                (response) => {
                    console.log('error', response)
                }
            )
        } else {
            fetchPost('/auth/' + this.props.match.params.token, {},
                (response) => {
                    console.log(response)
                    this.setState({ job: response })
                },
                (response) => {
                    console.log('error', response)
                }
            )
        }

    }

    onUpdateUserForm(signatureMethod) {
        this.state.job['user_form']['signture_method'] = signatureMethod
        this.state.job['user_form']['signed'] = 'YES'
        this.state.job['user_form']['date_signed'] = new Date()
        this.state.job['user_form']['uploaded_file'] = this.state.uploaded_file || ''
        this.state.job['user_form']['job_no'] = this.state.job['job_no']

        console.log('****************Update ', this.state.job['user_form'])

        fetchPost('/update/user_form', this.state.job['user_form'],
            (response) => {
                console.log(response)
                this.setState({ job: response })
            },
            (response) => {
                console.log('error', response)
            }
        )
    }

    onSubmit() {


        if (this.state['agent_interaction'] === 5 || this.state['overall_satisfaction'] === 5 || this.state['turnaround_satisfaction'] === 5) {
            if (this.state.job['job_no'].indexOf('ARC') > -1) {
                this.setState({ googleReview: true, url: 'https://g.page/r/CWwVAeEuEgNhEBM/review' })
            } else {
                this.setState({ googleReview: true, url: 'https://g.page/r/Cb-SS8DWnlH1EBM/review' })
            }
        }
        const body = {
            job_no: this.state.job['job_no'],
            issue_resolved: this.state['issue_resolved'],
            agent_interaction: this.state['agent_interaction'],
            turnaround_satisfaction: this.state['turnaround_satisfaction'],
            product_satisfaction: this.state['product_satisfaction'],
            overall_satisfaction: this.state['overall_satisfaction'],
            likely_to_recommend: this.state['likely_to_recommend'],
            review_note: this.state['review_note'],
            agent: this.state.job['agent'],
            google_reviewed: this.state.googleReview
        }

        fetchPost('/submit/' + this.props.match.params.token, body,
            (response) => {
                if (this.state.googleReview) {
                    this.setState({ section: this.state.section + 1, progress: this.state.progress + 1, submitted: false })
                } else {
                    this.setState({ section: this.state.section + 1, progress: this.state.progress + 1, submitted: true })
                }
            },
            (response) => {
                console.log('error', response)
            }
        )

    }

    onSubmitOTP() {
        this.setState({ onUploadCliked: false, isSubmitted: true, onSignClicked: false })

    }

    onUpload() {
        this.setState({ onUploadClicked: true, onSignClicked: false })
    }

    onSign() {
        this.setState({ onSignClicked: true, onUploadClicked: false })
    }

    googleRedirect() {
        this.setState({ is_loading_google: true })
        window.open(this.state.url, '_self')
    }

    onElectronicSignature = (event) => {
        this.setState({
            isElectronicSignature: event.target.checked,
            isManualSignature: false,
            isOtpSubmitted: false,
            isUploaded: false
        });
    };
    onAcceptenceFormViewed = (event) => {
        this.setState({
            isAcceptanceFormViewed: event.target.checked,
        });
    };


    onManualSignature = (event) => {
        this.setState({
            isManualSignature: event.target.checked,
            isElectronicSignature: false,
            isOtpSubmitted: false,
            isUploaded: false
        });
    };

    onResendOtp() {

    }

    handleOtpChange = (event, index) => {
        const value = event.target.value.replace(/[^0-9]/g, '');
        event.target.value = value;

        // 🔹 STORE OTP VALUE
        let otp = [...this.state.otp];
        otp += value;
        otp = otp.replace(/[^a-zA-Z0-9]/g, '');

        this.setState({ otp });

        // 🔹 MOVE TO NEXT INPUT
        if (value && index < 4) {
            const nextInput = document.getElementById(`otp-${index + 1}`);
            if (nextInput) {
                nextInput.focus();
            }
        }
    };


    onSubmitOTP = (signatureMethod) => {
        console.log('***********************', signatureMethod)
        if (this.state.otp === this.state.job.otp) {
            this.setState({
                isOtpSubmitted: true,
                isElectronicSignature: false,
                isEnabledManualSignature: false,
                isUploaded: false,
                otpValid: true
            })
        } else {
            this.setState({ isOTPValid: false })
        }
        this.onUpdateUserForm(signatureMethod);

    };

    onSubmitUpload = () => {
        // this.setState({
        //     isUploaded: true,
        //     isOtpSubmitted: false,
        //     isElectronicSignature: false,
        //     isManualSignature: false
        // })
    };

    openInNewTab = () => {
        const html = this.fetchInvoice();

        const newTab = window.open('', '_blank', 'noopener,noreferrer');

        newTab.document.open();
        newTab.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Invoice</title>
        <style>
          body {
            margin: 0;
            padding: 40px;
            background: #ebeff3;
            font-family: Arial, sans-serif;
          }
        </style>
      </head>
      <body>
        ${html}
      </body>
    </html>
  `);
        newTab.document.close();
    };


    handleUpload = () => {
        console.log("Clicked");

        const file = document.getElementById("fileInput").files[0];

        if (!file) {
            alert("No file selected");
            return;
        }

        console.log("File selected:", file.name);

        const storageRef = ref(storage, `uploads/${file.name}`);
        const uploadTask = uploadBytesResumable(storageRef, file);

        console.log("Upload task created");

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                console.log("Uploading...");
                console.log(snapshot.bytesTransferred, "/", snapshot.totalBytes);
            },
            (error) => {
                console.error("UPLOAD ERROR:", error);
            },
            async () => {
                console.log("Upload complete");
                const url = await getDownloadURL(uploadTask.snapshot.ref);
                this.setState({ uploaded_file: url })
                this.onUpdateUserForm('PDF UPLOAD');

                console.log("Download URL:", url);
            }
        );

        this.setState({
            isUploaded: true,
            isOtpSubmitted: false,
            isElectronicSignature: false,
            isManualSignature: false
        })
    };


    render() {
        const jobN0 = this.props.location.pathname.replace(/\//g, '')
        let isNPA = false;
        let isEnabledElectronicSignature = this.state.isElectronicSignature
        let isEnabledManualSignature = this.state.isManualSignature
        let isSubmitted = this.state.isOtpSubmitted
        let isSubmittedManually = this.state.isUploaded
        let cutomerFullName = '';
        const otpValid = this.state.isOTPValid
        const isAcceptanceFormViewed = this.state.isAcceptanceFormViewed
        this.state.isAlreadySigned = this.state.job ? true : false

        if (this.state.job) {
            cutomerFullName = this.state.job['customer']['full_name']
        }

        if (jobN0.includes('NPA')) {
            isNPA = true
            return (
                <Container fluid className='main-content-container m-auto'>
                    <div className='text-center'>
                        <div className="npa-title-box">
                            {/* {!this.stateisAlreadySigned && (<div class="alert alert-danger" role="alert">
                                You have already signed your user form.
                            </div>)} */}
                            <img
                                src="https://firebasestorage.googleapis.com/v0/b/s4biz-app.appspot.com/o/National_Prosecuting_Authority_logo.svg?alt=media&token=1cacc651-dac7-45b0-a3aa-208641e0bfac"
                                alt="National Prosecuting Authority Logo"
                                className="npa-logo"
                            />
                            <h3 className="npa-title">
                                National Prosecuting Authority  (NPA)
                            </h3>

                            <p className="npa-subtitle">
                                Secure and legally binding electronic approval process
                            </p>

                            <div className="npa-user">
                                <span className="npa-user-label">User:</span>
                                <FormInput
                                    id='job_no'
                                    placeholder='Autogenerated'
                                    disabled
                                    style={{ textAlign: 'center' }}
                                    value={cutomerFullName}
                                />
                            </div>

                            {(!this.state.isUploaded || !this.state.isOtpSubmitted) && (

                                <div className="npa-consent-section">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => this.props.history.push(`/${this.state.user_form['id']}/view`, {
                                            row: this.state.user_form,
                                            currentState: this.props.currentState,
                                            scroll: this.state.user_form

                                        })}
                                    >
                                        View User Acceptance Form
                                    </button>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="confirmRead"
                                            checked={this.state.isAcceptanceFormViewed}
                                            onChange={this.onAcceptenceFormViewed}
                                        />
                                        <label className="form-check-label" htmlFor="confirmRead">
                                            Acceptance Form Viewed ?
                                        </label>
                                    </div>
                                    {isAcceptanceFormViewed && (<div className="npa-checkbox-group">
                                        <h5 className="npa-consent-heading">
                                            Please select method of signature below
                                        </h5>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="confirmRead"
                                                disabled={this.state.isUploaded || this.state.isOtpSubmitted}
                                                checked={this.state.isElectronicSignature}
                                                onChange={this.onElectronicSignature}
                                            />
                                            <label className="form-check-label" htmlFor="confirmRead">
                                                Enter OTP ?
                                            </label>
                                        </div>
                                        <div className="form-check mt-2">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="confirmAgree"
                                                checked={this.state.isManualSignature}
                                                disabled={this.state.isUploaded || this.state.isOtpSubmitted}
                                                onChange={this.onManualSignature}
                                            />
                                            <label className="form-check-label" htmlFor="confirmAgree">
                                                Upload Signed Document ?
                                            </label>
                                        </div>
                                    </div>)}
                                </div>

                            )}

                        </div>

                    </div>

                    {isEnabledElectronicSignature && (<div>
                        <div className="npa-terms-section">
                            <h5 className="npa-section-heading">
                                User Acceptance Form & Terms and Conditions
                            </h5>

                            <div className="npa-terms-box">
                                <p>
                                    By proceeding with this electronic signing process, you confirm that you
                                    have read, understood, and agree to the terms and conditions outlined in
                                    this User Acceptance Form.
                                </p>

                                <p>
                                    This agreement governs your use of the National Prosecuting Authority
                                    electronic signature system and confirms your consent to sign documents
                                    electronically.
                                </p>

                                <h6 className="npa-sub-heading">
                                    Electronic Communications and Transactions Act (ECTA)
                                </h6>

                                <p>
                                    In terms of the <strong>Electronic Communications and Transactions Act,
                                        2002 (Act No. 25 of 2002)</strong> of South Africa, electronic signatures
                                    are legally recognised and enforceable.
                                </p>

                                <p>
                                    Section 13 of the Act provides that where an electronic signature is
                                    required by law, such a requirement is met if an advanced or agreed
                                    electronic signature is used and the method identifies the signatory and
                                    indicates their approval of the information communicated.
                                </p>

                                <p>
                                    By entering the One-Time Pin (OTP) and submitting this form, you acknowledge
                                    that:
                                </p>

                                <ul>
                                    <li>You are the authorised person to sign this document.</li>
                                    <li>Your electronic signature is legally binding.</li>
                                    <li>The signed document has the same legal effect as a handwritten signature.</li>
                                </ul>
                            </div>
                        </div>

                        <hr />

                        <Row className="justify-content-center align-items-center mb-3">
                            {[...Array(5)].map((_, index) => (
                                <Col key={index} xs="auto">
                                    <input
                                        type="text"
                                        maxLength={1}
                                        className="otp-input"
                                        onChange={(e) => this.handleOtpChange(e, index)}
                                        id={`otp-${index}`}
                                    />
                                </Col>
                            ))}

                            {/* Submit Button */}
                            {this.state.otp.length >= 5 && (<Col xs="auto">
                                <button
                                    type="button"
                                    className="btn btn-success otp-submit-btn"
                                    onClick={() => this.onSubmitOTP('OTP')}
                                >
                                    Submit
                                </button>
                            </Col>)}
                        </Row>


                        <Row className="justify-content-center">
                            <Col xs="auto">
                                <span className="otp-label">
                                    Enter 5-digit One-Time Pin (OTP)
                                </span>
                            </Col>
                        </Row>

                        <Row className="justify-content-center mt-2">
                            <Col xs="auto">
                                <button
                                    type="button"
                                    className="btn btn-link otp-resend-btn"
                                    onClick={() => this.onResendOtp()}
                                >
                                    Resend OTP
                                </button>
                            </Col>
                        </Row>
                    </div>)}

                    {isSubmitted && (<div className="alert alert-success text-center mt-3">
                        <strong>Thank you.</strong> Your electronic signature has been successfully submitted. <span style={{ color: 'red' }}><strong>Please close this page.</strong></span>
                    </div>)}

                    {!otpValid && (<div className="alert alert-danger text-center mt-3">
                        <strong>Incorrect OTP</strong> Please try again.
                    </div>)}

                    {isSubmittedManually && (<div className="alert alert-success text-center mt-3">
                        <strong>Thank you.</strong> Your document has been successfully submitted. <span style={{ color: 'red' }}><strong>Please close this page.</strong></span>
                    </div>)}


                    {isEnabledManualSignature && (<div className="npa-upload-section mt-3">
                        <label className="npa-upload-label">
                            Upload Signed User Acceptance Form
                        </label>

                        <input
                            type="file"
                            className="npa-upload-input"
                            accept=".pdf"
                            id="fileInput"
                        />

                        <small className="npa-upload-hint">
                            Accepted formats: PDF (Max 10MB)
                        </small>

                        <hr />
                        <button
                            type="button"
                            className="btn btn-success mt-3"
                            onClick={this.handleUpload}
                        >
                            Submit
                        </button>
                    </div>)}

                </Container>
            )
        }
        const percent = (progress) => {
            return (progress / 7) * 100
        }

        if (this.state.complete || (this.state.job && this.state.job.state === 'completed')) {
            <Container fluid className='main-content-container m-auto'>
                <div className='text-center'>
                    <h3 className='text-center'><strong className='text-muted d-block mb-2 text-center'>Service Evaluation</strong></h3>
                </div>
                <Row>
                    <Col lg="12" className="mb-2">
                        <Card small className="mb-4">
                            <CardBody className="p-4 pb-3">
                                <div>
                                    <Col
                                        sm='12' md='12'
                                    >
                                        <div style={{ width: '100%', display: 'flex' }}>
                                            <img
                                                id='main-logo'
                                                className='d-inline-block align-top mb-4'
                                                style={{ maxWidth: '120px', margin: 'auto' }}
                                                src={require('../assets/images/rating.png')}
                                                alt='Image'
                                            />
                                        </div>
                                        <h5><strong className='text-muted d-block mb-2 text-center'>Your review is complete!</strong></h5>
                                        <p className='text-muted d-block mb-2 text-center'>Thank you for taking the time to review our service and provide us with feedback that will help us improve it</p>
                                    </Col>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        }

        if (this.state.submitted) {
            return (
                <Container fluid className='main-content-container m-auto'>
                    <div className='text-center'>
                        <h3 className='text-center'><strong className='text-muted d-block mb-2 text-center'>Service Evaluation</strong></h3>
                    </div>
                    <Row>
                        <Col lg="12" className="mb-2">
                            <Card small className="mb-4">
                                <CardBody className="p-4 pb-3">
                                    <div className='py-3'>
                                        <Col
                                            sm='12' md='12'
                                        >
                                            <div style={{ width: '100%', display: 'flex' }}>
                                                <img
                                                    id='main-logo'
                                                    className='d-inline-block align-top mb-4'
                                                    style={{ maxWidth: '120px', margin: 'auto', maxHeight: '120px' }}
                                                    src={require('../assets/images/done.png').default}
                                                    alt='Image'
                                                />
                                            </div>
                                            <h5><strong className='text-muted d-block mb-2 text-center'>Thank You!</strong></h5>
                                            <p className='text-muted d-block mb-2 text-center'>We appreciate you taking the time to fill out this customer service review</p>

                                        </Col>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            )
        }

        return (
            <Container fluid className='main-content-container m-auto'>
                <div className='text-center'>
                    <h3 className='text-center'><strong className='text-muted d-block mb-2 text-center'>Service Evaluation</strong></h3>
                </div>
                <Row>
                    <Col lg="12" className="mb-2">
                        <Card small className="mb-4">
                            <CardBody className="p-4 pb-3">
                                {/* <Progress theme='accent' value={this.state.progress} className='mb-5'></Progress> */}
                                {this.sections().map((section, index) => {
                                    // if (index === this.state.section) {
                                    var thumbUp = {}
                                    var thumbDown = {}

                                    if (this.state[section.field] !== undefined) {
                                        if (this.state[section.field] === true) {
                                            thumbUp = { color: '#EBB748', fontSize: '3rem' }
                                            thumbDown = {}
                                        } else {
                                            thumbDown = { color: '#EBB748', fontSize: '3rem' }
                                            thumbUp = {}
                                        }
                                    }
                                    return (
                                        <div key={index} className='py-3'>
                                            <Col
                                                sm='12' md='12'
                                            >
                                                {section.image && (<div style={{ width: '100%', display: 'flex' }}>
                                                    <img
                                                        id='main-logo'
                                                        className='d-inline-block align-top mb-4'
                                                        style={{ maxWidth: '120px', margin: 'auto', maxHeight: '120px' }}
                                                        src={section.image}
                                                        alt='Image'
                                                    />
                                                </div>)}
                                                <h5><strong className='text-muted d-block mb-2 text-center'>{section.head}</strong></h5>
                                                <p className='text-muted d-block mb-2 text-center'>{section.description}</p>
                                                {(section.field && section.stars) && (
                                                    <div style={{ width: '100%', display: 'flex' }}>
                                                        <ReactStars
                                                            value={this.state[section.field]}
                                                            count={5}
                                                            onChange={(value) => {
                                                                const state = { message: null, canContinue: true }
                                                                state[section.field] = value
                                                                this.setState(state)
                                                            }}
                                                            half={false}
                                                            size={50}
                                                            color='#868e96'
                                                            color2='#EBB748'
                                                            className='my-2 mx-auto'
                                                        />
                                                    </div>
                                                )}
                                                {(section.field && section.boolean) && (
                                                    <div style={{ width: '168px', display: 'flex', margin: '1rem auto' }}>
                                                        <Button
                                                            type='button'
                                                            onClick={() => {
                                                                const state = { message: null, canContinue: true }
                                                                state[section.field] = false
                                                                this.setState(state)
                                                            }}
                                                            className='mr-2 transparent'>
                                                            <i className='material-icons' style={thumbDown}>thumb_down_alt</i>
                                                        </Button>
                                                        <div style={{ width: '8px' }} />
                                                        <Button
                                                            type='button'
                                                            onClick={() => {
                                                                const state = { message: null, canContinue: true }
                                                                state[section.field] = true
                                                                this.setState(state)
                                                            }}
                                                            className='mr-2 transparent'>
                                                            <i className='material-icons' style={thumbUp}>thumb_up_alt</i>
                                                        </Button>
                                                    </div>
                                                )}
                                                {section.text && <FormTextarea className='mb-1' placeholder='Type...' onChange={(e) => {
                                                    const state = {}
                                                    state[section.field] = e.target.value
                                                    this.setState(state)
                                                }} />}
                                                {section.foot && <p className='text-muted d-block mb-2 text-center'>{section.foot}</p>}
                                                {this.state.message && <p className='d-block my-4 text-center text-danger'>{this.state.message}</p>}
                                                {section.hasComplete && !this.state.googleReview && <Button type='button' rows={5} style={{ width: '100%' }} onClick={() => this.onSubmit()} className='mt-2'>Submit</Button>}

                                            </Col>
                                            <hr />
                                        </div>
                                    );
                                })}

                                {this.state.googleReview && (<Col

                                    sm='12' md='12'>
                                    <div class="alert alert-success text-center" role="alert">
                                        Would you like to rate us on Google? You will be entered into a monthly draw and stand a chance to win a fabulous prize.
                                    </div>
                                    <ButtonGroup className='mb-4'>
                                        <Button theme='danger' type='button' style={{ float: 'right' }} onClick={() => this.setState({ section: this.state.section + 1, progress: this.state.progress + 1, submitted: true })}> No, I am done.</Button>
                                        {!this.state.is_loading_google && (<Button theme='success' type='button' style={{ float: 'right' }} onClick={() => this.googleRedirect()}> Continue</Button>
                                        )}
                                        {this.state.is_loading_google && (<Button theme='success' type='button' disabled style={{ float: 'right' }}> Continue</Button>
                                        )}

                                    </ButtonGroup>
                                </Col>)}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default withRouter(Review)
